import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { INITIAL_THEME } from "./theme";
import Navigator from "./components/navigation/Navigator";
import Keycloak from "keycloak-js";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import RenderOnAuthenticated from "./components/RenderOnAuthenticated";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import LoadSxpChat from "./components/chatWidget";
import CONSTANTS from "./constants/constants";
import Wrapper from "./screen/Wrapper";
import Dialog from "@mui/material/Dialog";

const App = (props) => {
  const { config } = props;

  // !--------- KEYCLOAK CODE -------------

  const keycloak = Keycloak({
    realm: `${config.realm}`,
    url: `${config.authURL}auth/`,
    clientId: `${config.clientId}`,
  });

  const setTokens = (): void => {
    const { token, refreshToken, idTokenParsed }: any = keycloak;

    if (token && refreshToken && idTokenParsed) {
      sessionStorage.setItem(CONSTANTS.USER_EMAIL, idTokenParsed.email);
      sessionStorage.setItem(CONSTANTS.FIRST_NAME, idTokenParsed.given_name);
      sessionStorage.setItem(CONSTANTS.LAST_NAME, idTokenParsed.family_name);
      sessionStorage.setItem(CONSTANTS.USER_ID, idTokenParsed.sub);
      sessionStorage.setItem(CONSTANTS.REACT_TOKEN, token);
      sessionStorage.setItem(CONSTANTS.USER_TYPE, "user");
      sessionStorage.setItem("realm", config.realm);
      sessionStorage.setItem("gatewayURL", config.gatewayURL);
      sessionStorage.setItem("authURL", config.authURL);
      sessionStorage.setItem("clientId", config.clientId);
      sessionStorage.setItem("publicURL", config.publicURL);
      sessionStorage.setItem("logoURL", config.logoURL || "");
    }
  };
  const refreshAccessToken = (): void => {
    keycloak
      .updateToken(50)
      .then((refreshed: boolean) => {
        if (refreshed) {
          setTokens();
        }
      })
      .catch(() => {
        keycloak.logout();
        // sessionStorage.clear();
      });
  };

  const handleEvent = (event: string): void => {
    if (event === "onAuthSuccess") {
      if (window.location.href.indexOf("signup") > -1) {
        window.location.href = "/";
      }
      setTokens();
    }

    if (event === "onTokenExpired") {
      refreshAccessToken();
    }

    if (event === "onAuthLogout") {
      keycloak.logout();
      // sessionStorage.clear();
    }
    if (event === "OnAuthRefreshError") {
      keycloak.logout();
    }
  };

  const getAppChildren = () => (
    <ThemeProvider theme={INITIAL_THEME}>
      <Provider store={store}>
        <div className="appBackgroundContainer">
          <div className="appContainer">
            {/* Removing Dialog is effecting application styles */}
            <Dialog open={false} />
            <Wrapper>
              <Navigator />
              {/* <LoadSxpChat /> */}
            </Wrapper>
          </div>
        </div>
      </Provider>
    </ThemeProvider>
  );

  return (
    <div>
      <ReactKeycloakProvider
        autoRefreshToken={true}
        initOptions={{
          onLoad: "login-required",
          checkLoginIframe: false,
        }}
        authClient={keycloak}
        onEvent={handleEvent}
      >
        <RenderOnAuthenticated>{getAppChildren()}</RenderOnAuthenticated>
      </ReactKeycloakProvider>
    </div>
  );
};

export default App;
